import { useState, useEffect } from 'react';
import { getRackList, deleteRack } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const useRackList = () => {
    const [allRack, setAllRack] = useState<any[]>([]);
    const [rackList, setRackList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadRacks(false);
    }, []);

    const loadRacks = async (reload: boolean) => {
        try {
            if (rackList.length === 0 || reload) {
                const response = await getRackList();
                if (response) {
                    setRackList(response.data as never[]);
                    setAllRack(response.data as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading racks:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (rackId: number) => {
        try {
            await deleteRack(rackId);
            setRackList((prevList) => prevList.filter((rack: any) => rack.id !== rackId));
            uiHelper.showSuccessMessage("Rack has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting rack:', error);
            return false;
        }
    };

    const updateRackList = (result: any, isEdit: boolean, rackData: any) => {
        if (isEdit) {
            setRackList((prevList) =>
                prevList.map((rack: any) =>
                    rack.id === rackData.id ? { ...result } : { ...rack }
                )
            );
        } else {
            setRackList((prevList) => [{ ...result }, ...prevList]);
        }
    };

    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['name', 'warehouse_id'];
        filterDataBySearch(allRack, search, keysToSearch, setRackList);
    };

    return {
        rackList,
        isLoading,
        handleDelete,
        updateRackList,
        filterSearchData
    };
};